import resolveConfig from 'tailwindcss/resolveConfig'
import twConfig from '../tailwind.config'

export function useGetColorThemeStylesComponent(colorTheme: string | null) {
  return computed(() => {
    if (!colorTheme || colorTheme === 'blue') { // Blue is default
      return null
    }

    const { theme } = resolveConfig(twConfig)
    const colors = theme.colors[colorTheme]

    if (!colors) {
      console.warn(`No colors found for theme: ${colorTheme}`)
      return null
    }

    // Map the colors to CSS custom properties
    const colorStyles = {}
    const shades = ['50', '100', '200', '300', '400', '500', '600']

    shades.forEach((shade) => {
      if (shade in colors) {
        colorStyles[`--color-${shade}`] = colors[shade]
      }
    })

    return colorStyles
  })
}
